import { queryOptions } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import { pollUnlessLive } from "@/lib/api/realtime"
import type { ApiResource } from "@/lib/api/types"
import type { FoundPeople } from "@/types/found-person"

export const foundPeopleQueries = {
  /** Refetched when a sync says it changed the firm while Companies House syncs, and anyone's other appointments are fetched; polled only while the socket is down. */
  forFirm: (firmId: string) =>
    queryOptions({
      queryKey: apiKey(`/firms/${firmId}/people/found`),
      queryFn: async ({ signal }) => {
        const { data } = await apiFetch<ApiResource<FoundPeople>>(
          `/firms/${firmId}/people/found`,
          { signal }
        )

        return data
      },
      refetchInterval: (query) =>
        query.state.data?.checking ||
        query.state.data?.status === "syncing" ||
        query.state.data?.status === "pending"
          ? pollUnlessLive(3000)
          : false,
    }),
}
